module.exports = __webpack_public_path__ + "static/september-3-f8da400608931f9ac9604444496b8ecf.png";